import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { PrimaryButton, Text, SizeableRoundedDialog } from 'library';
import theme from 'theme';
import useLoading from 'library/hooks/useLoading';
import { formatShortWeekdayMonthDay } from 'shared/Dates';
import { ILeanShift } from '../../../BusinessJob/models';

import JobTimePicker from '../../../../../forms/components/pages/DateAndTimePage/JobTimePicker';
import moment from 'moment';
import useForm from 'parent-portal/forms/components/FormHook';
import { JobTimes } from 'parent-portal/forms/JobRequestTypes';
import { IShift } from 'models';
import { updateBusinessAppointment } from '../businessAppointmentApi';

export default function EditModalWithoutTimeChangeRequest({
    open,
    onClose,
    shift,
    providerName,
    refresh,
}: {
    open: boolean;
    onClose: () => void;
    shift: IShift | ILeanShift;
    providerName?: string;
    refresh: () => void;
}) {
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const { loading, setLoading } = useLoading();
    const form = useForm<{
        jobTimes: JobTimes;
    }>({ jobTimes: { start: moment(shift.start_date), end: moment(shift.end_date) } });
    function submit() {
        setLoading(true);
        updateBusinessAppointment(shift.id, {
            start_date: form.fieldStates.jobTimes.value.start?.toISOString(),
            end_date: form.fieldStates.jobTimes.value.end?.toISOString(),
        })
            .then(refresh)
            .finally(() => {
                setLoading(false);
                onClose();
            });
    }
    return (
        <SizeableRoundedDialog
            open={open}
            onClose={onClose}
            fullScreen={small}
            closeButton
            maxWidth="md"
            style={{ maxWidth: 500 }}
        >
            <Grid container item direction="column" style={{ padding: 20, gap: 10 }}>
                <Text variant="h1">Update times for {formatShortWeekdayMonthDay(shift.start_date)}?</Text>
                <Text>
                    {providerName
                        ? `We will inform ${providerName} of updates to the shift times. If there are any issues with this reschedule, we will update you as soon as possible.`
                        : 'We will attempt to fill this shift with the updated times. If you requested to book multiple providers for this shift, all unfilled shifts will be updated.'}
                </Text>
                <JobTimePicker
                    jobTimes={form.fieldStates.jobTimes}
                    jobDate={moment(shift.start_date)}
                    allowPastMidnight={false}
                />
                <PrimaryButton
                    disabled={loading}
                    onClick={submit}
                    buttonStyle={{ width: undefined, alignSelf: 'flex-end' }}
                >
                    Submit
                </PrimaryButton>
            </Grid>
        </SizeableRoundedDialog>
    );
}
